import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import VendorDetailsPage from '@totem/components/vendors/details/VendorDetailsPage';
import VendorsPage from '@totem/components/vendors/VendorPage';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const vendorManagementRoutes: Route[] = [
  {
    path: 'vendors',
    pageTitle: 'Vendors',
    component: VendorsPage,
    exact: true,
    breadcrumbs: [{ label: 'Vendors' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'vendors/:id',
    pageTitle: 'Vendor',
    component: VendorDetailsPage,
    exact: true,
    breadcrumbs: [
      { label: 'Vendors', link: '/vendors' },
      { label: 'Vendor Details' },
    ],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
];
